import "./module/plugin"
// import "./module/scroll"
import Swiper from "swiper/bundle"

const loading = document.getElementById('loading');
const accHeader = document.querySelectorAll('.cmn__accHeader');

window.onload = () => {
    setTimeout(() => {
        loading.classList.add('loaded');
    }, 4930 );
    sessionStorage.setItem('disp_popup', 'on');
};

if( sessionStorage.getItem('disp_popup') ) {
    loading.remove();

    var myswiper = new Swiper(".mv__innerSlider", {
        effect: "fade",
        centeredSlides: true,
        speed: 1000,
        loop:  true,
        autoplay: {
            delay: 4500,
            disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
        },
        simulateTouch:  false
    });

    accHeader.forEach(accHeaderIndex => {
        accHeaderIndex.addEventListener('click', () => {
            const accHeaderIndexPare = accHeaderIndex.parentNode;
            accHeaderIndexPare.classList.toggle('open');
        });
    });

    
} else {
    setTimeout(() => {
        var myswiper = new Swiper(".mv__innerSlider", {
            effect: "fade",
            centeredSlides: true,
            speed: 1000,
            loop:  true,
            autoplay: {
                delay: 4500,
                disableOnInteraction: false,
            },
            pagination: {
              el: ".swiper-pagination",
            },
            simulateTouch:  false
        });
    }, 5250 );

    accHeader.forEach(accHeaderIndex => {
        accHeaderIndex.addEventListener('click', () => {
            const accHeaderIndexPare = accHeaderIndex.parentNode;
            accHeaderIndexPare.classList.toggle('open');
        });
    });
}

import "./module/pjax"
